import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'

const Reklam = () => {
  const { t } = useTranslation()

  const useSnus = '../../../images/banner-section.png'

  return (
    <div>
     
          <img src={useSnus} alt="useSnus" className="w-full h-auto" />
    
    </div>
  )
}

export default Reklam
